<template>
  <div class="detailPage">
    <div class="topTitle">
      项目名称：<span style="color: aquamarine">{{
        projectInfo.projectName
      }}</span>
    </div>
    <div class="projectInfo">
      <div class="line">
        <div>
          当前项目节点：
          <span class="cusAdress">{{ projectInfo.nodeName }} </span>
        </div>
        <div>立项日期：{{ projectInfo.createDt | dataFormatT }}</div>
      </div>
      <div class="line">
        <div>节点负责人：{{ projectInfo.nodeLeaderName }}</div>
        <div>结束日期：{{ projectInfo.expectFinishTime | dataFormatT }}</div>
      </div>
      <div style="margin-top: 0.3125rem; display: flex; align-items: center">
        <div>节点负责人：</div>
        <div>
          <el-select
            v-model="projectInfo.nodeStatus"
            placeholder="请选择"
            :disabled="projectInfo.nodeLeaderCode !== loginName"
          >
            <el-option
              v-for="item in nodeStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="btnBox">
        <el-button type="info"
          @click="goBack"
          ><i class="el-icon-arrow-left"></i
          ><i class="el-icon-arrow-left"></i>返回</el-button
        >
        <el-button type="primary" @click="addWork">添加工作结果</el-button>
      </div>
    </div>
    <div class="recordsList">
      <div class="list" v-for="(item, index) in workList" :key="index">
        <p>{{ item.createDt | dataFormatT }}:{{ item.content }}</p>
      </div>
    </div>

    <!-- 添加工作结果 -->
    <el-dialog
      title="添加工作结果"
      :visible.sync="dialogVisible"
      width="80%"
      class="workDialog"
    >
      <div class="dialogBox">
        <div class="project">
          <p>{{ projectInfo.projectName }}</p>
          <p>{{ gettime }}</p>
        </div>
        <div class="content">
          <div class="box">
            <textarea
              rows="10"
              placeholder="请输入内容"
              v-model="workResult"
              class="textarea"
              id="textarea"
              @keydown="handleKeyCode($event)"
            ></textarea>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveProjectNodesLog()"
          >确 定</el-button
        >
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nodeStatusList: [
        {
          value: "0",
          label: "待处理",
        },
        {
          value: "1",
          label: "待跟进",
        },
        {
          value: "2",
          label: "协助处理",
        },
        {
          value: "3",
          label: "处理中",
        },
        {
          value: "4",
          label: "已完成",
        },
        {
          value: "5",
          label: "挂起",
        },
      ],
      projectInfo: {},
      dialogVisible: false,
      gettime: null,
      workResult: "1、",
      projectStatusList: [
        {
          value: "1",
          label: "需求中",
        },
        {
          value: "2",
          label: "切图中",
        },
        {
          value: "3",
          label: "ui中",
        },
        {
          value: "4",
          label: "开发中",
        },
        {
          value: "5",
          label: "提测",
        },
        {
          value: "6",
          label: "交付中",
        },
        {
          value: "7",
          label: "已交付",
        },
        {
          value: "8",
          label: "挂起",
        },
        {
          value: "9",
          label: "维护",
        },
      ],
      projectStatus: "1",
      loginName: "",
      workList: [],
      inputList:['1、'],
      name:'',
    };
  },
  mounted() {
    this.getCurrentTime();
    clearInterval(myTimeDisplay);
    let myTimeDisplay = setInterval(() => {
      this.getCurrentTime(); //每秒更新一次时间
    }, 1000);
  },
  created() {
    this.loginName = this.$route.query.loginName;
    this.projectInfo = this.$route.query.projectInfo;
    console.log("this.projectInfo", this.$route.query.projectInfo);
    this.getWorkList();
    this.getUserInfo();
  },
  methods: {
    cancelSave(){
      this.dialogVisible = false;
      this.workResult = '1、'
    },
    handleKeyCode(event) {
      if (event.keyCode == 13) {
        var index = this.inputList.length + 1;
        console.log('index',index);
        for(let i = index-1;i>0;i--){
          console.log('位置',this.workResult.indexOf(i+'、'));
          if(this.workResult.indexOf(i+'、') == -1){
            this.inputList.pop(this.inputList[i-1])
          }
        };
        var ind = this.inputList.length +1;
        this.inputList.push(ind + '、');
        this.workResult = this.workResult + `\n` + ind + '、';
        // this.workResult = this.workResult +  ind + '、';
        event.preventDefault()
      }
    },
    // 获取系统时间
    getCurrentTime() {
      //获取当前时间并打印
      var _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      _this.gettime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
      _this.currtime = yy + "-" + mm + "-" + dd + " ";
      this.Samplingtime = _this.gettime;
    },
    // 查询日志记录
    getWorkList() {
      let sendData = {};
      sendData.nodeCode = this.projectInfo.nodeCode;
      sendData.createorCode = this.$route.query.loginName
      this.$http.post("/projectNodesLog/queryList", sendData).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          this.workList = res.data.data;
        }
      });
    },
    addWork() {
      this.dialogVisible = true;
    },
    // 查询用户信息
    getUserInfo(){
      let sendData = {}
      sendData.loginName = this.$route.query.loginName;
      this.$http.post("/userInfo/queryOne", sendData).then((res) => {
        console.log('/userInfo/queryOne',res.data.data);
        if (res.data.code == 200) {
          this.name = res.data.data.name
        }
      });
    },
    //保存工作日志
    saveProjectNodesLog() {
      var that = this;
      var data = {
        id: this.projectInfo.id,
        content: this.workResult,
        createorCode: this.$route.query.loginName,
        createorName: this.name,
      };
      that.$http
        .post("/projectNodesLog/saveProjectNodesLog", data)
        .then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: "提示",
              message: "保存成功",
              showClose: true,
            });
            that.dialogVisible = false;
            that.getWorkList();
            that.workResult = "1、";
          } else {
            that.$notify.error({
              title: "提示",
              message: res.data.message,
              showClose: true,
            });
            that.dialogVisible = false;
          }
        });
    },
    goBack() {
      this.$router.push({
        path: "/dailyRecords",
        query: { loginName:this.loginName },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.detailPage {
  width: 100%;
  .topTitle {
    padding: 0.625rem 1.25rem;
    border-bottom: 1px solid #efefef;
  }
  .projectInfo {
    width: 100%;
    padding: 0.625rem;
    box-sizing: border-box;
    border-bottom: 1px solid #efefef;
    .line {
      display: flex;
      justify-content: space-between;
      margin-top: 0.3125rem;
      div {
        display: flex;
        align-items: center;
        .cusAdress {
          display: inline-block;
          width: 4.375rem;
          /* 关键代码 */
          text-overflow: ellipsis; /* 溢出显示省略号 */
          overflow: hidden; /* 溢出隐藏 */
          white-space: nowrap; /* 强制不换行 */
        }
      }
    }
    /deep/.el-input__inner {
      width: 9.375rem;
    }
    .btnBox {
      display: flex;
      justify-content: space-between;
      margin-top: 1.25rem;
    }
  }
  .recordsList {
    padding: 1.25rem 0.625rem;
    box-sizing: border-box;
    .list {
      border: 1px solid #efefef;
      border-radius: 0.3125rem;
      margin-bottom: 0.625rem;
      padding: 0 0.625rem;
      box-sizing: border-box;
    }
  }
  /deep/.el-dialog__header {
    background-color: #fff;
    padding: 0.625rem;
    border-top-left-radius: 0.125rem;
    border-top-right-radius: 0.125rem;
    text-align: center;
  }

  /deep/.el-dialog__header .el-dialog__title {
    line-height: 1.25rem;
    font-size: 1rem;
    color: #000;
  }
  /deep/.el-dialog__footer {
    text-align: center;
  }
  .workDialog {
    .dialogBox {
      padding: 0 1.25rem;
      border: 0.3125rem solid #000;
      border-image-source: url(../assets/images/border.png);
      border-image-slice: 20 0 20 0;
      background-color: transparent;
      .project {
        display: flex;
        justify-content: space-around;
      }
      .content {
        position: relative;
        overflow: hidden;
        box-sizing: border-box;
        background-color: transparent;
        .box {
          height: 21.25rem;
          .textarea {
            position: absolute;
            padding-top: 0.3125rem;
            width: 100%;
            box-sizing: border-box;
            background-color: transparent;
            border: 0;
            outline: none;
            display: block;
            line-height: 2rem;
            font-size: 0.9375rem;
            z-index: 2;
          }
        }
      }
      .content:before {
        position: absolute;
        content: "____________________________________________________________________________\A____________________________________________________________________________\A____________________________________________________________________________\A____________________________________________________________________________\A____________________________________________________________________________\A____________________________________________________________________________\A____________________________________________________________________________\A____________________________________________________________________________\A____________________________________________________________________________\A____________________________________________________________________________\A";
        z-index: 1;
        left: 0;
        top: 0;
        width: 100%;
        color: silver;
        line-height: 1.6;
        font-size: 1.25rem;
      }
    }
  }
}
</style>